import { CONSULT_TYPE_FOLLOW_UP } from 'Constants/consults';
import { MODAL_TYPES } from 'Constants/modal';
import { MESSAGES_COUNT_PER_PAGE } from 'Constants/webchat';
import { addModal, removeModal } from 'Redux/modules/modal/actions';
import {
  conversationActive,
  createConsult,
  getMessagesBackwardByTime,
} from 'Redux/modules/webChat/actions';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

const useCreateFollowUp = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const goToConversation = useCallback(
    (conversationId, clinicId) => {
      dispatch(
        getMessagesBackwardByTime({
          conversationId,
          count: MESSAGES_COUNT_PER_PAGE,
          timestamp: Date.now(),
        }),
      );
      if (!history?.location?.pathname?.includes(`/web-chat/${clinicId}`)) {
        history.push(`/web-chat/${clinicId}`);
      }
      dispatch(conversationActive(conversationId));
      dispatch(removeModal(MODAL_TYPES.CONFIRM_GO_TO_ON_GOING_CONSULT));
    },
    [dispatch, history],
  );

  const createAFollowUp = async (doctorId, body) => {
    setLoading(true);
    try {
      const consult = await dispatch(createConsult(doctorId, body));
      const { id: conversationId } = consult.data.conversation;
      if (consult?.data?.consultType !== CONSULT_TYPE_FOLLOW_UP) {
        dispatch(
          addModal({
            type: MODAL_TYPES.CONFIRM_GO_TO_ON_GOING_CONSULT,
            id: MODAL_TYPES.CONFIRM_GO_TO_ON_GOING_CONSULT,
            data: { goToConversation: () => goToConversation(conversationId, body.clinicId) },
          }),
        );
      } else {
        goToConversation(conversationId, body.clinicId);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      // console.log(e);
    }
  };

  return {
    createAFollowUp,
    loading,
  };
};

export default useCreateFollowUp;
